/**
 * Well-known key written into React Router's `location.state` by the
 * preserved-navigation primitives whenever a caller passes `dropParams`.
 *
 * `QueryParamPreserver` reads this key and skips the listed params when
 * restoring previously-present query keys, so an intentional drop is not
 * silently undone by the safety net.
 *
 * Exported as a constant (rather than inlined) so that the producer and
 * consumer cannot drift out of sync.
 */
export const DROPPED_QUERY_PARAMS_STATE_KEY = '__droppedQueryParams' as const;
